export async function getAvailableMethodCollectingUseCase(repository, assignedMethods) {
  const result = await repository.getCatalog();
  if (!result.success) return result;

  const assignedCodes = new Set(assignedMethods.map((method) => method.code).filter(Boolean));
  const assignedIds = new Set(assignedMethods
    .map((method) => method.method_collecting_id ?? (method.code ? null : method.id))
    .filter((id) => id != null)
    .map(String));
  return {
    ...result,
    data: result.data.filter((method) =>
      !assignedCodes.has(method.code) && !assignedIds.has(String(method.id)),
    ),
  };
}
